import type { UniversalPHP } from '@php-wasm/universal';

interface ZipWpContentOptions {
	/**
	 * @private
	 * A temporary workaround to enable including the WordPress default theme
	 * in the exported zip file.
	 */
	selfContained?: boolean;
}

/**
 * Replace the current wp-content directory with one from the provided zip file.
 *
 * @param playground Playground client.
 * @param wpContentZip Zipped WordPress site.
 */
export const zipWpContent = async (
	playground: UniversalPHP,
	{ selfContained = false }: ZipWpContentOptions = {}
) => {
	const fileBuffer = await playground.readFileAsBuffer('/tmp');

	return fileBuffer;
};

const zipFunctions = ``;

async function runPhpWithZipFunctions(playground: UniversalPHP, code: string) {
	return await playground.run({
		code: ``,
	});
}
